import { render, staticRenderFns } from "./BemzLogin.vue?vue&type=template&id=62e2086a&scoped=true"
import script from "./BemzLogin.vue?vue&type=script&lang=js"
export * from "./BemzLogin.vue?vue&type=script&lang=js"
import style0 from "./BemzLogin.vue?vue&type=style&index=0&id=62e2086a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e2086a",
  null
  
)

export default component.exports